export default __webpack_public_path__ + "static/media/weather-watch-logo.cec2a272.png";